
import { useState, useEffect } from 'react'
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddCompetency } from "./Modal/AddCompetency";
import { CompetencyList } from "../Common/CompetencyList"
import Swal from 'sweetalert2'
import axios from 'axios'
import { AllCompetencyList } from '../Common/AllCompetencyList';
import { IconButton, Tooltip } from '@mui/material';
import { Add } from '@mui/icons-material';

export default function CompetencyLibraries() {
    const [show, setShow] = useState(false);
    const [popupType, setPopupType] = useState("Add");
    const [editId, setEditId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [competencies, setCompetencies] = useState([]);
    
    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
    console.log("Updated userId", userId)
    }, [userId])

    const handleAdd = (userId) => {
        setUserId(userId)
        setEditId(0);
        setPopupType('Add');        
        setShow(true);
    }

    const getList = async () => {
        let apiUrl = "/api/sa_competencies";

        await axios.get(apiUrl).then(function (response) {
            let result = response.data;
            if (result.success) {
                setCompetencies(result.data);
            } else {
                // Handle error or set isError state if needed.
            }
        });
    };

    const [accordion, setAccordion] = useState({});
    const [isChange, setIsChange] = useState(false);
    const handleAccordionChange = (key) => {
        console.log("key", key)
        if(accordion && accordion[key]){
            accordion[key] = !accordion[key]
        }
        else{
            accordion[key] = true
        }
        setIsChange((prev) => !prev);
        // Get the accordion button element
        const accordionButton = document.querySelector(`[data-key="${key}"]`);
        console.log("accordionButton",accordionButton)
        // Toggle the active class on the accordion button
        accordionButton.classList.toggle('active');
      }
    return(
        <Layout>
            <Header pageTitle={'Competencies'} />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="">
                    <div className="card-header d-flex justify-content-between align-items-center">                      
                        <h3 className="fw-bold mb-0">Competency Libraries</h3>
                        {/* <button type="button" onClick={() => handleAdd()} className="btn btn-primary">
                            <span className="tf-icons bx bx-plus"></span>&nbsp; Add Competency
                        </button> */}
                    </div>

                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                            <div className="col-md mb-4 mb-md-0">
                                <div className="accordion" id="accordionExample1">
                                    {competencies.map((competency) => (
                                        <div className="card accordion-item" key={competency.userId}>
                                            <h2 className="accordion-header d-flex align-items-center" id="headingOne">
                                                <button type="button" onClick={() => handleAccordionChange("accordionn1"+competency.userId)} className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target={"#accordionn1"+competency.userId} aria-expanded="false" aria-controls={"accordionn1"+competency.userId}  data-key={"accordionn1"+competency.userId}>
                                                    <b>{competency.organizationName} - {competency.name}</b>
                                                </button>
                                                <div className="d-flex align-items-center">
                                                    <Tooltip title="Add Competency" size='small' className='icon icon-sm icon-theme me-3' onClick={() => handleAdd(competency.userId)}>
                                                        <IconButton>
                                                            <Add />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {/* <Switch className="Rj-toggle" color="info" onChange={(e) => handleSurveyStatus(e, survey.id)} defaultChecked={survey.status === '1' ? true : false}/> */}
                                                    {/* <Tooltip 
                                                        onClick={() => handleSurveyClone(survey)} 
                                                        title="Clone Survey" 
                                                        size='small' 
                                                        className='icon icon-sm icon-primary'
                                                    >
                                                        <IconButton>
                                                            <ContentCopyIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip onClick={() => handleEdit(survey.id)} title="Edit Survey" size='small' className='icon icon-sm icon-secondary me-3 ms-2'>
                                                        <IconButton>
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip onClick={() => handleSurveyDelete(survey.id)} title="Delete Survey" size='small' className='icon icon-sm icon-primary me-3'>
                                                        <IconButton>
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip> */}
                                                </div>
                                            </h2>

                                            <div id={"accordionn1"+competency.userId} className={accordion && accordion["accordionn1"+competency.userId] ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="table-responsive">

                                                        <AllCompetencyList competencies={competency.competencies} getList={getList} userId={competency.userId}/>
                                            
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {show && (
                <AddCompetency
                    type={popupType}
                    show={show}
                    setShow={setShow}
                    getList={getList}
                    editId={editId}
                    setEditId={setEditId}
                    userId={userId}
                />
            )}
            {/* <AddCompetency type={popupType} show={show} setShow={setShow} getList={getList} editId={editId} setEditId={setEditId} userId={userId}/> */}
        </Layout>
    )
}